import { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import messages from "./module/messages";
import { IGrantType, IOTPModalProps } from "./module/constants";

import classes from "./OTPModal.module.scss";
import { FaClock } from "react-icons/fa";
import { CssTextField } from "../../../TextInputField/TextInputField";
import { connect } from "react-redux";
import {
  postOTPAction,
  resetModalOtpStateAction,
  setOTP,
  setUser,
} from "../../../../pages/Login/module/actions";
import {
  otpLoginSelector,
  responseOtpSelector,
  selectRetrysCount,
  userLoginSelector,
} from "../../../../pages/Login/module/selectors";
import { createStructuredSelector } from "reselect";
import { IDataPostLogin } from "../../../../pages/Login/module/constants";
import { IResponseState } from "../../ResponseModal/module/constants";
import CustomModal from "../../CustomModal/CustomModal";
import { selectUserInfo } from "../../../../App/module/selectors";
import { LOGIN_CLIENT_ID } from "../../../../module/constants";

const OTPModal = (props: IOTPModalProps) => {
  const {
    show,
    maximumTime,
    requireUserCode,
    securityAllowed = false,
    onContinueLinkClick,
    onConfirm,
    onClose,
    userProp,
    otpProp,
    modalOtpState,
    setUserProp,
    setOtpProp,
    sendOtp,
    isLoginPage,
    currentLoggedUser,
    resetModalOtpState,
    retrysLeft,
    onConfirmOperation,
  } = props;

  const [showLabelSecurityQuestions, setShowLabelSecurityQuestions] =
    useState(false);
  const [userCode, setUserCode] = useState("");
  const [otp, setOtp] = useState("");

  useEffect(() => {
    setUserProp("");
    setUserCode(userProp);
    setOtpProp("");
    setOtp(otpProp);
    setShowLabelSecurityQuestions(false);
  }, []);

  useEffect(() => {
    if (show) {
      setOtp("");
      setUserCode("");
    }
  }, [show]);

  useEffect(() => {
    if (retrysLeft <= 0) {
      setShowLabelSecurityQuestions(true);
    }
  }, [retrysLeft]);

  const handleTimeout = () => {
    setShowLabelSecurityQuestions(true);
  };

  const handleUserFieldChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (event.target) {
      const usr = event.target.value;
      setUserCode(usr);
      setUserProp(usr);
    }
  };

  const handleOtpFieldChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target) {
      const code = event.target.value;
      setOtp(code);
      setOtpProp(code);
    }
  };

  const handleSendOtp = () => {
    // LOGIN PAGE HANDLER
    if (isLoginPage && otp && userCode) {
      //todo costruzione data (body?)
      let body = {} as IDataPostLogin;
      body = {
        grant_type: IGrantType.OTP,
        username: userProp,
        password: otp,
        client_id: LOGIN_CLIENT_ID, //??
      };
      var formBody: any = [];
      Object.keys(body).forEach((key) => {
        let encodedKey = encodeURIComponent(key);
        // @ts-ignore // ToDo -> fix types
        let encodedValue = encodeURIComponent(body[key]);
        formBody.push(encodedKey + "=" + encodedValue);
      });
      formBody = formBody.join("&");

      sendOtp(formBody);
    }
    // UPDATE PWD PAGES HANDLER
    if (!isLoginPage && otp) {
      onConfirmOperation(otp);
    }
  };

  return (
    <>
      <Modal
        show={show}
        size={"sm"}
        onHide={onClose}
        centered
        contentClassName={classes.content}
      >
        <Modal.Header className={classes.header}>
          <Modal.Title style={{ fontSize: "1rem" }}>
            {requireUserCode ? (
              <FormattedMessage {...messages.OTPUserCodeModalTitle} />
            ) : (
              <FormattedMessage {...messages.OTPModalTitle} />
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ fontSize: "0.75rem" }}>
          <div style={{ textAlign: "center" }}>
            {requireUserCode && (
              <>
                <div>
                  <FormattedMessage {...messages.OTPUserCodeModalLabel} />
                </div>
                <div>
                  <CssTextField
                    variant="filled"
                    fullWidth
                    type={"text"}
                    onChange={handleUserFieldChange}
                    value={userCode}
                    label={
                      <FormattedMessage {...messages.OTPUserCodeModalLabel} />
                    }
                  />
                </div>
                <br />
              </>
            )}
            <div>
              <FormattedMessage {...messages.OTPModalLabel} />
            </div>
            <div>
              <CssTextField
                variant="filled"
                fullWidth
                type={"text"}
                onChange={handleOtpFieldChange}
                value={otp}
                label={<FormattedMessage {...messages.OTPModalLabel} />}
              />
            </div>

            {retrysLeft <= 0 && (
              <>
                <div style={{ paddingTop: "15px" }}>
                  <div
                    style={{ display: "inline" }}
                    className={`${classes.timertimeout}`}
                    id="countdown"
                  >
                    <FormattedMessage
                      {...messages.OTPModalOutOfRetrysMessage}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </Modal.Body>

        <Modal.Footer className={classes.footer}>
          <div className={classes.btnWrapper}>
            <button
              className={`${classes.btn} ${classes["btn-cancel"]}`}
              onClick={onClose}
            >
              <FormattedMessage {...messages.OTPModalClose} />
            </button>

            <button
              className={`${classes.btn} ${classes["btn-confirm"]}`}
              onClick={handleSendOtp}
            >
              <FormattedMessage {...messages.OTPModalConfirm} />
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

const mapStateToProps: any = () =>
  createStructuredSelector({
    userProp: userLoginSelector,
    modalOtpState: responseOtpSelector,
    currentLoggedUser: selectUserInfo,
    retrysLeft: selectRetrysCount,
  });

const mapDispatchToProps: any = {
  setUserProp: (user: string) => setUser(user),
  setOtpProp: (otp: string) => setOTP(otp),
  sendOtp: (body: IDataPostLogin) => postOTPAction(body),
  resetModalOtpState: () => resetModalOtpStateAction(),
};

//CONST CONNECT
const withConnect: any = connect(mapStateToProps, mapDispatchToProps);

export default withConnect(OTPModal);
